export default __webpack_public_path__ + "static/media/cert-hr-hkgcsmeaa.0df9093a.jpg";